class Select {
    constructor(domElement) {
        this.domElement = domElement;
    }

    vaciar() {
        var i, L = this.domElement.options.length - 1;
        for(i = L; i >= 0; i--) {
            this.domElement.remove(i);
        }
    }

    opciones(opciones) {
        this.vaciar();
        this.textoPorDefecto();
        const numeroOpciones = opciones.length;
        for (let i=0; i<=numeroOpciones-1; i++){
            let opcion = opciones[i];
            this.opcion(opcion);
        }
    }

    cargando(textoCargando) {
        this.vaciar();
        var opt = document.createElement('option');
        opt.value = '';
        opt.innerHTML = textoCargando;
        this.domElement.appendChild(opt);
    }

    textoPorDefecto() {
        this.opcion({valor: '', texto: 'Selecciona...'});
    }

    opcion(opcion) {
        var opt = document.createElement('option');
        opt.value = opcion.valor;
        opt.innerHTML = opcion.texto;
        this.domElement.appendChild(opt);
    }

}

export default Select;